/** New Koneko timer UI (React prototype). */
export const DEFAULT_NEW_KONEKO_TIMER_URL =
  "https://timer.neko-logic.com/";

export function getNewKonekoTimerUrl() {
  const raw = String(process.env.VUE_APP_NEW_KONEKO_TIMER_URL || "").trim();
  return raw || DEFAULT_NEW_KONEKO_TIMER_URL;
}

/**
 * Retire legacy Active Timer UI (navbar, play/stop, nav item).
 * Set VUE_APP_LEGACY_TIMER_RETIRED=0 on localhost to keep testing the old page.
 * Non-localhost hosts default to retired unless explicitly disabled at build time.
 */
export function isLegacyTimerRetired() {
  const raw = String(process.env.VUE_APP_LEGACY_TIMER_RETIRED || "")
    .trim()
    .toLowerCase();
  if (raw === "0" || raw === "false" || raw === "no") return false;
  if (raw === "1" || raw === "true" || raw === "yes") return true;
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const onLocalDev =
      host === "localhost" || host === "127.0.0.1" || host.endsWith(".local");
    if (!onLocalDev) return true;
  }
  return false;
}

export function legacyTimerRetirementMessage() {
  return "The Active Timer in NekoHR has moved to the new time & tasks app. Use that app to start and stop your timer.";
}
